import _Promise from "babel-runtime/core-js/promise";
export var makeCancelablePromise = function makeCancelablePromise(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new _Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
    }, function (error) {
      return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};